__turbopack_context__.v({
  "cardCopy": "RingMeasuresSection-module__o0UDHq__cardCopy",
  "cardDesc": "RingMeasuresSection-module__o0UDHq__cardDesc",
  "cardImg": "RingMeasuresSection-module__o0UDHq__cardImg",
  "cardImgDesktop": "RingMeasuresSection-module__o0UDHq__cardImgDesktop",
  "cardImgMobile": "RingMeasuresSection-module__o0UDHq__cardImgMobile",
  "cardTitle": "RingMeasuresSection-module__o0UDHq__cardTitle",
  "carouselRegion": "RingMeasuresSection-module__o0UDHq__carouselRegion",
  "content": "RingMeasuresSection-module__o0UDHq__content",
  "copy": "RingMeasuresSection-module__o0UDHq__copy",
  "dot": "RingMeasuresSection-module__o0UDHq__dot",
  "dotActive": "RingMeasuresSection-module__o0UDHq__dotActive",
  "dotFill": "RingMeasuresSection-module__o0UDHq__dotFill",
  "dots": "RingMeasuresSection-module__o0UDHq__dots",
  "head": "RingMeasuresSection-module__o0UDHq__head",
  "media": "RingMeasuresSection-module__o0UDHq__media",
  "outer": "RingMeasuresSection-module__o0UDHq__outer",
  "slide": "RingMeasuresSection-module__o0UDHq__slide",
  "subtitle": "RingMeasuresSection-module__o0UDHq__subtitle",
  "tab": "RingMeasuresSection-module__o0UDHq__tab",
  "tabActive": "RingMeasuresSection-module__o0UDHq__tabActive",
  "tabHighlight": "RingMeasuresSection-module__o0UDHq__tabHighlight",
  "tabList": "RingMeasuresSection-module__o0UDHq__tabList",
  "title": "RingMeasuresSection-module__o0UDHq__title",
  "track": "RingMeasuresSection-module__o0UDHq__track",
  "viewport": "RingMeasuresSection-module__o0UDHq__viewport",
});
